<template>
  <div>
    <a-modal
      :open="visible"
      :title="force ? '请修改密码' : '修改密码'"
      :closable="true"
      :maskClosable="false"
      :keyboard="false"
      @cancel="handleClose"
      @update:open="handleUpdateOpen"
    >
      <template #footer>
        <a-button key="back" @click="handleClose">关闭</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOk"
          >提交</a-button
        >
      </template>
      <p v-if="force" style="color: #fa8c16; margin-bottom: 12px">
        当前为简易默认密码（123456），请修改后再继续使用
      </p>
      <p>请输入您的新密码：</p>
      <a-input-password v-model:value="newPassword" placeholder="新密码" />
      <p style="margin-top: 12px">请确认您的新密码：</p>
      <a-input-password v-model:value="confirmPassword" placeholder="确认新密码" />
    </a-modal>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch, defineProps, defineEmits } from "vue";
import { message } from "ant-design-vue";
import { getCurrentTimestamp } from "@/utils/solt/timestamp";
import { sortByMd5WithSalt } from "@/utils/solt";
import { updateUserInfo } from "@/api/user";

const props = defineProps<Props>();
const emit = defineEmits(["close", "success"]);

const loading = ref<boolean>(false);
const newPassword = ref<string>("");
const confirmPassword = ref<string>("");

watch(
  () => props.visible,
  (val) => {
    if (!val) {
      newPassword.value = "";
      confirmPassword.value = "";
    }
  },
);

/** 仅允许通过关闭按钮关闭：拦截遮罩等非主动关闭 */
const handleUpdateOpen = (open: boolean) => {
  if (!open) {
    // 不在这里关闭，统一走 handleClose / @cancel
    return;
  }
};

const handleClose = () => {
  emit("close");
};

const handleOk = async () => {
  if (!newPassword.value || !confirmPassword.value) {
    message.info("请填写完整密码");
    return;
  }
  if (newPassword.value !== confirmPassword.value) {
    message.info("两次密码不一致");
    return;
  }
  if (newPassword.value === "123456") {
    message.error("密码过于简单，请设置更复杂的密码");
    return;
  }
  loading.value = true;
  try {
    const time = await getCurrentTimestamp();
    const obj = {
      password: newPassword.value,
      repassword: confirmPassword.value,
      timestamp: time,
    };
    const sign = await sortByMd5WithSalt(obj);
    const res = await updateUserInfo({
      password: newPassword.value,
      repassword: confirmPassword.value,
      timestamp: time,
      sign: sign,
    });
    if (res?.code == 200) {
      message.success(res?.msg || "修改成功");
      try {
        const userInfo = JSON.parse(localStorage.getItem("UserInfo") || "{}");
        userInfo.must_change_password = 0;
        localStorage.setItem("UserInfo", JSON.stringify(userInfo));
      } catch (e) {}
      emit("success");
      emit("close");
    } else {
      message.info(res?.msg);
    }
  } catch (error) {
    console.error("更新失败", error);
  } finally {
    loading.value = false;
  }
};

interface Props {
  visible: boolean;
  force?: boolean;
}
</script>

<style scoped>
</style>
